import React from "react";
import ReactDOM from "react-dom/client";
// import { ReactDOM } from "react";
import App from "./App";
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App/>);